import { createLightTheme } from "../default/Light";

const res = createLightTheme({ colorAccent: "#EB2553" });
res.default.logoSize = { width: 15.7, height: 2.4 };
export default res;
